import React, { useState, Fragment, useCallback, useEffect } from 'react';
import { translate } from '../../Services/translation';
import BuyButtonPack from '../BuyButtonPack/BuyButtonPack';
import { useDispatch } from 'react-redux';
import { reloadPayment } from '../../Actions/Checkout.action';
import { update } from '../../Actions/Cart.action';
import Icon from '../IconBase/Icon';
import CartProductCardMobile from './CartProductCardMobile';
import CartProductCardDesktop from './CartProductCardDesktop';
import(`./styles/${window.__litium.themeName}.scss`);

const quantityDispatch = (articleNumber, quantity, type, dispatch) => {
  mapCartToAbort[articleNumber] = new AbortController();
  dispatch(update(articleNumber, quantity, mapCartToAbort[articleNumber])).then(
    () => {
      if (type !== 'minicart') {
        dispatch(reloadPayment());
      }
    }
  );
};

const mapCartToAbort = {};

const CartProducts = (props) => {
  const { cart, mobile, type, b2c } = props;
  const [orderRows, setOrderRows] = useState(cart?.orderRows);
  const dispatch = useDispatch();

  const handleQuantityInput = useCallback(
    (articleNumber, quantity, rowSystemId, ensureCorrectness = true) => {
      // In case of onBlur event, we need ensureCorrectness as true in order to ensure if the value is a valid float number
      // In case of onChange event, we accept invalid float number, but we don't send any request to the server.
      mapCartToAbort[articleNumber] && mapCartToAbort[articleNumber].abort();
      let floatQuantity = parseFloat(quantity);
      let validValue = !isNaN(floatQuantity) && floatQuantity > 0;
      if (ensureCorrectness) {
        quantity = validValue ? floatQuantity : 1;
        floatQuantity = quantity;
        validValue = true;
      }
      const index = orderRows.findIndex(
        (item) => item.rowSystemId === rowSystemId
      );
      const oldQuantity = parseFloat(cart.orderRows[index].quantity);
      if (floatQuantity !== oldQuantity && validValue) {
        quantityDispatch(articleNumber, quantity, type, dispatch);
      }
      const tempOrderRows = [...orderRows];
      tempOrderRows[index] = {
        ...tempOrderRows[index],
        quantity,
      };
      setOrderRows(tempOrderRows);
    },
    [dispatch, orderRows, cart.orderRows]
  );

  const removeOrderRow = useCallback(
    (articleNumber) =>
      dispatch(update(articleNumber, 0)).then(() => dispatch(reloadPayment())),
    [dispatch]
  );

  return cart.orderRows.map((orderRow) =>
    mobile ? (
      <CartProductCardMobile
        {...{ orderRow, type, b2c, handleQuantityInput, removeOrderRow }}
      />
    ) : (
      <CartProductCardDesktop
        {...{ orderRow, type, b2c, handleQuantityInput, removeOrderRow }}
      />
    )
  );
};

export default CartProducts;
